
import { Component, DestroyRef, inject, Input, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { PanelComponent } from '@components/core/panel/panel.component';
import { EntityService } from '@services/core/entity.service';
import { NgbModal, NgbNavModule, NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { FormBuilder, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { UserService } from '@services/core/user.service';
import { NgSelectModule } from '@ng-select/ng-select';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Component({
  selector: 'app-user-management',
  templateUrl: './users-management.component.html',
  styleUrls: ["./users-management.component.scss"],
  imports: [DragDropModule, FormsModule, NgSelectModule, NgbTooltipModule, PanelComponent, ReactiveFormsModule],
  providers: [UserService],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: true,
})
export class UsersManagementComponent implements OnInit {
  // @Input() period
  // @Input() entity

  private _userService = inject(UserService)
  private _entityService = inject(EntityService)
  private _fb = inject(FormBuilder)
  private _modalService = inject(NgbModal)
  private destroyRef = inject(DestroyRef)
  protected users = []
  protected search = ""
  protected roles
  protected offices
  protected entities

  private modalOptions = {
    size: 'xl',
    scrollable: true,
    animation: true,
    backdrop: null
  }
  public closeResult = ""
  protected newUserForm = this._fb.group({
    id: [""],
    mail: ["", Validators.required],
    roleId: ["", Validators.required],
    officeId: ["", Validators.required],
    entityId: [""],
    enabled: [true],
  })

  // protected certpro
  // protected showEditCategory = false
  // protected items
  // protected item_sel
  // protected certProTypes
  // protected typeCertPro
  // public closeResult = ""
  // public question = ""



  ngOnInit(): void {
    this.getRoles();
    this.getOffices();
    this.getEntities();
  }

  open(modal, data?) {
    this.newUserForm.patchValue(data);
    this._modalService.open(modal, this.modalOptions).result.then((result) => {
      this.closeResult = `Closed with: ${result}`;
    }, (reason) => {
      this.closeResult = `${reason}`;
    });
  }

  getRoles() {
    this._userService.getRoles().pipe(takeUntilDestroyed(this.destroyRef)).subscribe((roles) => {
      this.roles = roles;
    });
  }

  getOffices() {
    this._entityService.getOffices().pipe(takeUntilDestroyed(this.destroyRef)).subscribe((offices) => {
      this.offices = offices;
    });
  }

  getEntities() {
    this._entityService.getEntities().pipe(takeUntilDestroyed(this.destroyRef)).subscribe((entities) => {
      this.entities = entities;
    });
  }

  getUsers() {
    this._userService.getUsers(this.search).pipe(takeUntilDestroyed(this.destroyRef)).subscribe((users) => {
      this.users = users;
    });
  }

  saveUser(){
    this._userService.updateUser(this.newUserForm.value).pipe(takeUntilDestroyed(this.destroyRef)).subscribe((user) => {
      this.newUserForm.reset();
      this.getUsers();
    });
  }

  updateUser(user: any, enabled: boolean){
    if(enabled) user.enabled = enabled;
    this._userService.updateUser(user).pipe(takeUntilDestroyed(this.destroyRef)).subscribe((user) => {
      this.getUsers()
    });
  }

} 
